export default __webpack_public_path__ + "static/media/notFound.09cc746f.png";